import styled, { css } from 'styled-components';
import { landscape, mediaDesktop } from 'utils/responsive';
import { Paragraph1 } from 'utils/styles/typography';

export default styled(Paragraph1)`
  width: 96%;
  margin: 0;

  ${landscape} {
    font-size: 2.5vw;
  }

  ${mediaDesktop(css`
    font-size: 1.5vw;
  `)}
`;
